import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f06eb14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main-context" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { LANG_TYPE } from '@/i18n/langType'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseContents',
  props: {
  // 言語設定
  language: {
    type: String,
    default: LANG_TYPE.JA,
  },
},
  setup(__props) {

const props = __props

log.trace('LicenseContents setup start.')

// プロパティ定義


log.trace('LicenseContents setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t('body.agree.contents1', props.language)), 1),
    _hoisted_2,
    _hoisted_3,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.contents2', props.language)), 1),
    _hoisted_4,
    _hoisted_5,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.contents3', props.language)), 1),
    _hoisted_6,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.contents4', props.language)), 1),
    _hoisted_7,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.contents5', props.language)), 1),
    _hoisted_8,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.contents6', props.language)), 1),
    _hoisted_9,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.contents7', props.language)), 1),
    _hoisted_10,
    _hoisted_11,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.title', props.language)), 1),
    _hoisted_12,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part1.title', props.language)), 1),
    _hoisted_13,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part1.contents1', props.language)), 1),
    _hoisted_14,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part1.contents2', props.language)), 1),
    _hoisted_15,
    _hoisted_16,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part2.title', props.language)), 1),
    _hoisted_17,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part2.contents', props.language)), 1),
    _hoisted_18,
    _hoisted_19,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part3.title', props.language)), 1),
    _hoisted_20,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part3.contents', props.language)), 1),
    _hoisted_21,
    _hoisted_22,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part4.title', props.language)), 1),
    _hoisted_23,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part4.contents', props.language)), 1),
    _hoisted_24,
    _hoisted_25,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part5.title', props.language)), 1),
    _hoisted_26,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part5.contents', props.language)), 1),
    _hoisted_27,
    _hoisted_28,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part6.title', props.language)), 1),
    _hoisted_29,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading1.part6.contents', props.language)), 1),
    _hoisted_30,
    _hoisted_31,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading2.title', props.language)), 1),
    _hoisted_32,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading2.contents', props.language)), 1),
    _hoisted_33,
    _hoisted_34,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading3.title', props.language)), 1),
    _hoisted_35,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading3.contents', props.language)), 1),
    _hoisted_36,
    _hoisted_37,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading4.title', props.language)), 1),
    _hoisted_38,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading4.contents', props.language)), 1),
    _hoisted_39,
    _hoisted_40,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading5.title', props.language)), 1),
    _hoisted_41,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('body.agree.heading5.contents', props.language)), 1),
    _hoisted_42,
    _hoisted_43
  ]))
}
}

})